import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ReglementService } from '../../../@core/data/rest/reglement/reglement-service';
import { Reglement } from '../../../@core/data/model/reglement';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { Validator } from '../../../@core/data/model/validator';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { FactureService } from '../../../@core/data/rest/facture/facture-service';
import { PartenaireService } from '../../../@core/data/rest/partenaire/partenaire-service';
import { Partenaire } from '../../../@core/data/model/partenaire';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ListingFormModalComponent } from '../function/listing.modal.component';
import { Facture } from '../../../@core/data/model/facture';
import { CashSessionService } from '../../../@core/data/rest/caisse/cashsession-service';
import { AuthService } from '../../../auth/auth.service';
import { CashSession } from '../../../@core/data/model/cashsession';
import { SessionFormComponent } from '../../caisse/form/sessionform.component';
import { CalculatorComponent } from '../../caisse/calculator/caculator.modal.component';




@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-reglement',
  templateUrl: './reglementform.component.html' ,
  styles: [`
    button {
      margin: 1rem;
    }
  `],
})
export class ReglementFormComponent {

  @Input() reglementEdit: Reglement;
  @Input() saveToApi: boolean;
  @Input() typePartner: string;
  @Input() typeOp: string;
  // @Input() showInvoice: boolean;

  select: number;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  dropdownListCompte = [];
  selectedItemsCompte = [];
  dropdownSettingsCompte = {};


  dateReglement: NgbDateStruct;
  test: string;

  datePart: string;
  timePart: string;

  constructor(
      protected dialogRef: NbDialogRef<ReglementFormComponent>,
      private dialogService: NbDialogService,
      public reglementService: ReglementService,
      public cashSessionService: CashSessionService,
      public sharedMethods: SharedMethods,
      private factureService: FactureService,
      public partenaireService: PartenaireService,
      public authService: AuthService,
      private changeDedectionRef: ChangeDetectorRef,
      public modalService: NgbModal) {



  }


  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {

      if (this.reglementEdit.date_flux !== undefined) {

        const tabDate = this.reglementEdit.date_flux.split(' ');
        this.datePart = tabDate[0];
        this.timePart = tabDate[1];

      }

      this.dropdownSettings = {
        singleSelection: true,
        idField: 'id',
        textField: 'nom',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'recherche',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
      };

      this.dropdownSettingsCompte = {
        singleSelection: true,
        idField: 'id',
        textField: 'labelNomSelect',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'recherche',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
      };

      if (this.reglementEdit.id !== 0 && this.reglementEdit.facture !== undefined && this.reglementEdit.facture !== null) {
        this.selectedItems = [
          this.reglementEdit.facture.partenaire,
        ];

        this.reglementEdit.partenaire =  this.reglementEdit.facture.partenaire;
      }


      // chargement des parteanires
      if (this.reglementEdit.partenaire !== undefined) {

        this.selectedItems = [plainToClass(Partenaire, this.reglementEdit.partenaire)];

      } else {

        if (this.partenaireService.getLocalPartner(this.typePartner) === undefined || this.partenaireService.getLocalPartner(this.typePartner) === []) {


          this.partenaireService.getPartner(this.typePartner).then( partners => {

              this.dropdownList = partners;


              if (this.reglementEdit.partenaire !== undefined) {

                this.selectedItems = [plainToClass(Partenaire, this.reglementEdit.partenaire)];

              }

          });

        } else {

            this.dropdownList = this.partenaireService.getLocalPartner(this.typePartner);


            if (this.reglementEdit.partenaire !== undefined) {

              this.selectedItems = [plainToClass(Partenaire, this.reglementEdit.partenaire)];

            }

        }

      }



      // chargement compte trésererie
      if ( this.typeOp !== 'caisse') {

        if ( this.cashSessionService.sessions === undefined) {

          let user: string;
          if (this.authService.token.user.id === null || this.authService.token.user.id === 0 || this.authService.token.user.id === undefined) {
            user = '';
          } else {
            user = this.authService.token.user.id.toString();
          }

          this.cashSessionService.getSessions('', '', user, 'all').then( sessions => {

            const pat = [];

            sessions.forEach( elem => {

              if ( elem.nature === 'espece' || elem.nature === 'banque' || elem.nature === 'depot') {

                pat.push( elem);

              }

            });

            this.dropdownListCompte = plainToClass( CashSession, pat);

          });

        } else {

            const pat = [];

            this.cashSessionService.sessions.forEach( elem => {

              if ( elem.nature === 'espece' || elem.nature === 'banque' || elem.nature === 'depot') {

                pat.push( elem);

              }

            });

            this.dropdownListCompte = plainToClass( CashSession, pat);

          this.dropdownListCompte = plainToClass( CashSession, pat);
        }

      }



  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterContentChecked(): void {
      this.changeDedectionRef.detectChanges();
  }

  cancel() {
    if (this.reglementService.iSconnecting === false) {
        this.dialogRef.close();
    }
  }

  submit() {
    // alert(JSON.stringify(this.dateReglement));
    // alert('nature: ' + this.reglementEdit.nature_reglement + ' montant: ' + this.reglementEdit.montant.toString());
    // this.dialogRef.close();

    // this.reglementEdit.date_flux = this.sharedMethods.converNgbDateStructToString(this.dateReglement);

    if ( this.datePart !== undefined) {
        this.reglementEdit.date_flux  = this.datePart;

        if ( this.timePart !== undefined)
        this.reglementEdit.date_flux  += ' ' + this.timePart;
    }

    let valid: Validator;
    valid = this.sharedMethods.validateReglement (this.reglementEdit);

    if (valid.result) {

      if ( !this.saveToApi) {

        this.dialogRef.close(this.reglementEdit);

      } else {

        if (this.reglementService.iSconnecting === false) {

            this.reglementService.saveReglement(this.reglementEdit).then( reglement => {

                // il est préférable de renvoyer this.reglementEdit.id pour eviter des eventuelles bug
                /* this.reglementEdit.id = reglement.id;
                this.reglementEdit.date_flux = reglement.date_flux;
                this.reglementEdit.label_nature = reglement.label_nature;
                this.reglementEdit.cash_session_name = reglement.cash_session_name;
                this.reglementEdit.cash_session_id = reglement.cash_session_id;
                this.dialogRef.close(this.reglementEdit); */
                // alert(JSON.stringify(this.fluxstockedit));

                // this.reglementService.saveReglementEvent.next(plainToClass(Reglement, reglement as object));

                this.dialogRef.close(plainToClass(Reglement, reglement as object));

            });
        }

      }

    } else {

        this.sharedMethods.toastShow('error', valid.title, valid.message);

    }


  }

  openFacture() {

    // alert('');
    if (this.reglementEdit.partenaire !== null && this.reglementEdit.partenaire !== undefined) {

        const modalRef = this.modalService.open(
        ListingFormModalComponent,
        { centered: true,
          backdrop: 'static',
          size: 'lg',
          // windowClass: 'modal-xxl',
        });

        modalRef.componentInstance.partenaire = this.reglementEdit.partenaire;

        if ( this.typePartner === 'client')
        modalRef.componentInstance.typeOp = 'vente';

        if ( this.typePartner === 'fournisseur')
        modalRef.componentInstance.typeOp = 'achat';

        modalRef.componentInstance.closeOnSelect = true;

        modalRef.componentInstance.to = '';
        modalRef.componentInstance.from = '';

        modalRef.result.then((result) => {
          // this.closeResult = `Closed with: ${result}`;
          // alert(result);
        }, (reason) => {

            // const factureEdit = plainToClass(Facture, reason);
            // tslint:disable-next-line:no-console
            // console.log(event.data);

            if (reason !== undefined && reason !== null && reason.id !== 0) {

              /* const datefacturation  = new Date(reason.date_facturation);
              const datefrom = new Date(this.settingService.from);
              const dateto = new Date(this.settingService.to);

              if (typeEdit === 'add' ) {


              }

              if (typeEdit === 'update' ) {


              } */

              this.reglementEdit.facture = reason;

              this.reglementEdit.montant = reason.reste;


            }

        });

      } else {

        this.sharedMethods.toastShow('warning', 'Partenaire non selectionné', 'Selectionnez un partenaire');
      }


  }

  onItemSelect(item: any) {
    this.reglementEdit.partenaire = item;
  }

  onDeSelect(item: any) {
    this.reglementEdit.partenaire = undefined;
  }

  onSelectAll(items: any) {
    // tslint:disable-next-line:no-console
    console.log(items);
  }

  onItemSelectCompte(item: any) {
    // tslint:disable-next-line:no-console
    // console.log(item);
    this.reglementEdit.cashsession = item;
  }

  onDeSelectCompte(item: any) {
    this.reglementEdit.cashsession = undefined;
  }

  onSelectAllCompte(items: any) {
    // tslint:disable-next-line:no-console
    console.log(items);
  }


  addAccount() {

    const session = new CashSession;
    session.nature = 'espece';

    const closeOnBackdropClick = false;
    this.dialogService.open(SessionFormComponent, {
      closeOnBackdropClick,
      context: {
        sessionEdit: plainToClass(CashSession, session as object),
        naturesToExclude: ['credit'],
      },
    }).onClose.subscribe(data => {

        if ( data !== undefined ) {

          this.dropdownListCompte.push(plainToClass( CashSession, data as object));
          this.selectedItemsCompte = [plainToClass( CashSession, data as object)];
          this.reglementEdit.cashsession = data;

        }

    });

  }

  openCalculator() {

    const closeOnBackdropClick = true;
    this.dialogService.open(CalculatorComponent, {
      closeOnBackdropClick,
      context: {
        // produit: pr,
      },
    }).onClose.subscribe( data => {

      if (data !== undefined && data !== null) {

        // alert(data);
        this.reglementEdit.montant = data;
      }


    });

  }

}
